/**
 * IMPORTANT: DO NOT MODIFY THIS FILE MANUALLY
 */

import * as appRegistrationViewScope from './appRegistrationViewScope';
/** DO NOT DELETE THIS LINE, IMPORT SUBAPP HERE **/

const subApps = [
    appRegistrationViewScope,
    /** DO NOT DELETE THIS LINE, APPEND SUBAPP HERE **/
];

export const SubApps = [];

for (const subApp of subApps) {
    SubApps.push({
        name: subApp.name,
        app: subApp.App,
        params: subApp.params
    });
}

const subAppsRoutes = {
    /** DO NOT DELETE THIS LINE, APPEND SUBAPP ROUTE HERE **/
    appRegistrationViewScope: appRegistrationViewScope.open,
};

export default subAppsRoutes;
